export enum LotConfigStep {
  CONFIRM = "confirm",
  REVIEW = "review",
}
